export default function(){
   /** @type {HTMLElement[]} */
   const centerScroll = document.getElementById('nav-scroll-to-center');
   centerScroll?.scrollIntoView({
      behavior: "smooth",
      inline: "end",
   });
}